// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import {
  savePlatform,
  getPlatformById,
} from '../../../../actions/platformActions';
import { toast } from 'react-toastify';
import PlatformForm from '../components/PlatformForm';
import { useForm } from 'react-hook-form';
import KwPanel from '../../../common/KwPanel';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';

function EditPlatform({ done, id, cancel, savePlatform, getPlatformById }) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [file, setFile] = useState();
  const [platform, setPlatform] = useState({});

  useEffect(() => {
    if (id) {
      getPlatformById(id).then((d) => {
        setPlatform(d);
      });
    }
  }, [id, getPlatformById]);

  const onSubmit = (data) => {
    savePlatform({ ...platform, ...data, file }).then(() => {
      toast.success(t('Platform saved'));
      done(platform);
    });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit platform') : t('Add platform')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          key="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-platform-button"
        />
      }
    >
      <KwPanel className="mb-4 pb-1" testId="platform-details-panel">
        <PlatformForm
          platform={platform}
          register={register}
          errors={errors}
          control={control}
          setFile={setFile}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}



function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {
  savePlatform,
  getPlatformById,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPlatform);
